<template>
  <div
    ref="scrollableContent"
    class="shizen-stats-overview basic-gray-section f-h scrollable"
    @scroll="checkScrollHeight()"
  >
    <ChartPeriodSelector
      ref="periodSelector"
      v-model="displayConfig"
      :default-expanded="defaultPeriodsExpanded"
      :text="`${$t('message.STATS_OVERVIEW_TITLE')} - ${displayName}`"
      :preset-id="presetId"
      :query-prefix="'shizenStats'"
      :instant-update="true"
      @presetPick="presetId = $event"
      @expand="periodsExpanded"
    />
    <div v-if="selectedStats.isFormatted" class="shizen-stats-overview__container f-h-below-title">
      <div class="shizen-stats-overview__informations">
        <div class="shizen-stats-overview__breadcrumb">
          <RouterLink
            class="shizen-stats-overview__breadcrumb__item"
            to="/shizen-stats/overview/"
          >
            Statistiques
          </RouterLink>
          <span v-for="(entry, i) in breadcrumb" :key="i">
            <span v-if="Object.keys(entry).length !== 0">
              &nbsp;►&nbsp;
              <RouterLink class="shizen-stats-overview__breadcrumb__item" :to="`/shizen-stats/overview/${entry.link}`">
                {{ entry.text }}
              </RouterLink>
            </span>
          </span>
        </div>
        <button
          v-if="getTypeData !== 'allDatas'"
          class="action-btn shizen-stats-overview__informations__button"
          @click="previousPath()"
        >
          {{ $t('message.BACK') }}
        </button>
        <div class="shizen-stats-overview__informations__header">
          <div v-if="selectedStats" class="shizen-stats-overview__informations__header__texts">
            <div class="shizen-stats-overview__informations__profile">
              <Icon
                v-if="this.$route.params.userId"
                :style="generateIconColor"
                class="shizen-stats-overview__informations__profile__img"
              >
                {{ personMedium }}
              </Icon>
              <Icon
                v-else-if="this.$route.params.teamId"
                :style="generateIconColor"
                class="shizen-stats-overview__informations__profile__img"
              >
                {{ teamMedium }}
              </Icon>
              <img
                v-else-if="this.$route.params.companyId"
                class="shizen-stats-overview__informations__profile__img"
                :src="summaryCompanyPicture"
              >
              <img
                v-else
                class="shizen-stats-overview__informations__profile__img"
                src="/images/logo300.png"
                alt
              >
              <p class="shizen-stats-overview__informations__profile__name">
                {{ displayName }}
              </p>
            </div>
            <div v-if="getTypeData !== 'users'" class="shizen-stats-overview__informations__profile__stats">
              <p>
                <span class="legend">{{ `${$t('message.ACTIONS')}${$t('message.TWO_DOTS')}` }}</span>
                <span>{{ displayActions }}</span>
              </p>
              <p>
                <span class="legend">{{ `${$t('message.PROBLEMS')}${$t('message.TWO_DOTS')}` }}</span>
                <span>{{ displayProblems }}</span>
              </p>
              <p>
                <span class="legend">{{ `${$t('message.USERS')}${$t('message.TWO_DOTS')}` }}</span>
                <span>{{ $tc('message.N_USERS', selectedStats.nUsers, { n: selectedStats.nUsers }) }}</span>
              </p>
            </div>
          </div>
          <div class="shizen-stats-overview__informations__profile__stats__btn__container">
            <button class="action-btn" @click="exportToExcel">
              {{ $t('message.RATING_EXPORT_BUTTON') }}
            </button>
            <button
              :class="!isRefreshDone && 'shizen-stats-overview__informations__profile__stats__btn__animation'"
              class="action-btn shizen-stats-overview__informations__profile__stats__btn"
              @click="refresh(true)"
            >
              {{ $t('message.OVERVIEW_REFRESH') }}
            </button>
            <p v-if="!isRefreshDone" class="shizen-stats-overview__informations__profile__stats__btn__text">
              {{ $t('message.OVERVIEW_REFRESH_WARNING') }}
            </p>
          </div>
        </div>
        <div class="shizen-stats-overview__charts">
          <ExpandableSettingsItem
            v-for="(item, i) in Object.keys(chartsByCategories)"
            :key="i"
            class="shizen-stats-overview__charts__categories"
            :class="!chartsByCategories[item].length && 'shizen-stats-overview__charts__categories__disabled'"
            :html-id="String(i)"
            :title="statsCategories[item].name"
            use-transition-expand
          >
            <p
              v-if="!chartsByCategories[item].length"
              class="shizen-stats-overview__no-data"
            >
              {{ $t('message.STATS_NODATA') }}
            </p>
            <div v-else class="chart-container">
              <div
                v-for="(chart, j) in chartsByCategories[item]"
                :key="j"
                class="chart"
              >
                <p
                  v-if="!chart.datasets[0].data.some(item => item !== null)"
                  class="shizen-stats-overview__no-data chart__empty-message"
                >
                  {{ $t('message.STATS_NODATA') }}
                </p>
                <StatsChart
                  :class="!chart.datasets[0].data.some(item => item !== null) && 'chart__item__disabled'"
                  :height="70"
                  :width="100"
                  :chart-data="chart"
                  :options="chart.unit === 'time' ? timeChartOptions(chart) : defaultChartOptions"
                />
              </div>
            </div>
          </ExpandableSettingsItem>
        </div>
      </div>
      <div class="shizen-stats-overview__informations__other">
        <ExpandableSettingsItem
          v-if="getTypeData !== 'users'"
          style="margin-top: 1em;"
          default-expand
          :html-id="'98'"
          :title="displayListTitle"
          use-transition-expand
        >
          <p
            v-if="allDatas && !allDatas.some(item => item !== null)"
            class="shizen-stats-overview__no-data"
          >
            {{ $t('message.STATS_NODATA') }}
          </p>
          <div v-else>
            <div class="basic-search-field v-centerer">
              <Icon>{{ searchMedium }}</Icon>
              <input v-model="cardsSearch" :placeholder="$t('message.SEARCH_PH')">
            </div>
            <div class="shizen-stats-overview__card-container mt10em">
              <SummaryInformationsStatsCard
                v-for="(company, key) in limitedCardsList"
                :key="key"
                :current-data="company"
                :data-type="getTypeData"
                :display="!dataIsFormatting"
                :company-picture="getCompanyPicture(company)"
              />
            </div>
          </div>
          <div v-if="filteredCardsList.length > limitedCardsList.length" class="h-v-centerer">
            <button class="action-btn" @click="cardsDataLimit += 30">
              {{ $t('message.LOAD_MORE') }}
            </button>
          </div>
        </ExpandableSettingsItem>
      </div>
      <div class="shizen-stats-overview__informations__other">
        <ExpandableSettingsItem
          v-if="getTypeData !== 'users'"
          default-expand
          :html-id="'99'"
          :title="$t('message.SUMMARY_STATS')"
          use-transition-expand
        >
          <StatsSheet
            :current-data="allDatas"
            :loading="allCompaniesLoading"
            :data-type="getTypeData"
            :display="!dataIsFormatting"
          />
        </ExpandableSettingsItem>
      </div>
    </div>
    <ScrollTop :visible="scrollTopVisible" @scroll-top="scrollToTop()" />
    <LoadingOverlay v-model="allCompaniesLoading" class="shizen-stats-overview__loading" />
    <LoadingOverlay v-model="dataIsFormatting" class="shizen-stats-overview__loading" />
  </div>
</template>

<script>
/**
 * Page accessible to Shizen staff only in order to analyze how the solution is used.
 * Stats about companies/teams/users reporting problems, creating actions,
 * carrying out field tours, meetings, etc can be displayed.
 *
 * This page also features a sortable table of all the companies/teams/users of Shizen.
 *
 */

import { cloneDeep } from 'lodash';
import { mapState } from 'vuex';
import { timeStepSizes } from '@/utils/shizen-stats-utils';
// Vuex
import { GET_INDICATOR_DISPLAY_CONFIGS } from '@/store/mutation-types';
import { FETCH_SHIZEN_STATS } from '@/store/modules/shizen-stats/action-types';
import { FORMAT_SHIZEN_STATS } from '@/store/modules/shizen-stats/mutation-types';
// Components
import ChartPeriodSelector from '@/components/chart-period-selector.vue';
import ExpandableSettingsItem from '@/components/expandable-settings-item.vue';
import Icon from '@/components/icon.vue';
import LoadingOverlay from '@/components/loading-overlay.vue';
import ScrollTop from '@/components/scroll-top.vue';
import StatsChart from '@/components/shizen-stats/stats-chart.vue';
import StatsSheet from '@/components/shizen-stats/stats-sheet.vue';
import SummaryInformationsStatsCard from '@/components/shizen-stats/summary-informations-stats-card.vue';
// Utils & Assets
import { personMedium, searchMedium, teamMedium } from '@/assets/icons';
import { calcPeriodStartDate, getRandomColor, secondsToArray } from '@/utils/main';
import { ChartHelper, computeConfigStart } from '@/utils/indicator-utils';
import { exportRatingsToExcel } from '@/utils/rating-utils';


export default {

  name: 'ShizenStatsOverview',

  components: {
    ChartPeriodSelector,
    ExpandableSettingsItem,
    Icon,
    LoadingOverlay,
    ScrollTop,
    StatsChart,
    StatsSheet,
    SummaryInformationsStatsCard,
  },

  data() {
    return {
      // Icons
      personMedium,
      searchMedium,
      teamMedium,

      cardsDataLimit: 30,
      cardsSearch: '',
      scrollTopVisible: false,
      summaryCompanyPicture: '',
      isRefreshDone: true,
      dataIsFormatting: false,
      displayConfig: this.$store.getters.defaultMonthlyDisplayConfig,
      chartData: {},
      dataTypes: {
        actionCreatingTime: {
          name: this.$t('message.CHARTS_TIME_CREATING_ACTION'),
          type: 'line',
          color: '#55A1E5',
          unit: 'time',
          display: ['shizen', 'company', 'team', 'user'],
          category: ['Development'],
        },
        pbCreatingTime: {
          name: this.$t('message.CHARTS_TIME_CREATING_PB'),
          type: 'line',
          color: '#55A1E5',
          unit: 'time',
          category: ['Development'],
        },
        bugsReported: {
          name: this.$t('message.CHARTS_BUGS_REPORTED'),
          type: 'line',
          color: '#55A1E5',
          unit: this.$t('message.CHARTS_BUGS_UNIT'),
          category: ['CustomerSuccess'],
        },
        tasksReported: {
          name: this.$t('message.CHARTS_TASKS_REPORTED'),
          type: 'line',
          color: '#55A1E5',
          unit: this.$t('message.CHARTS_TASKS_UNIT'),
          category: ['CustomerSuccess'],
        },
        createdActions: {
          name: this.$t('message.CHARTS_CREATED_ACTIONS'),
          type: 'line',
          color: '#55A1E5',
          unit: this.$t('message.CHARTS_ACTIONS_UNIT'),
          category: ['Marketing', 'ProductLife'],
        },
        finishedActions: {
          name: this.$t('message.CHARTS_FINISHED_ACTIONS'),
          type: 'line',
          color: '#55A1E5',
          unit: this.$t('message.CHARTS_ACTIONS_UNIT'),
          category: ['Marketing'],
        },
        createdPb: {
          name: this.$t('message.CHARTS_CREATED_PB'),
          type: 'line',
          color: '#55A1E5',
          unit: this.$t('message.CHARTS_PB_UNIT'),
          category: ['Marketing', 'ProductLife'],
        },
        finishedPb: {
          name: this.$t('message.CHARTS_FINISHED_PB'),
          type: 'line',
          color: '#55A1E5',
          unit: this.$t('message.CHARTS_PB_UNIT'),
          category: ['Marketing'],
        },
        finishedMeetings: {
          name: this.$t('message.CHARTS_FINISHED_MEETINGS'),
          type: 'line',
          color: '#55A1E5',
          unit: this.$t('message.CHARTS_MEETINGS_UNIT'),
          category: ['ProductLife'],
        },
        login: {
          name: this.$t('message.CHARTS_CONNECTION_FREQUENCY'),
          type: 'line',
          color: '#55A1E5',
          unit: this.$t('message.CHARTS_LOGIN_UNIT'),
          category: ['CustomerSuccess'],
        },
        time: {
          name: [this.$t('message.CHARTS_TIME_ONLINE'), this.$t('message.CHARTS_TIME_OFFLINE')],
          type: 'bar',
          color: ['#55A1E5', '#FFD500'],
          unit: 'time',
          category: ['Marketing', 'CustomerSuccess', 'ProductLife'],
        },
      },
      defaultChartOptions: {
        plugins: {
          datalabels: {
            anchor: 'start',
            align: 'top',
            offset: 0,
            color: '#58595B',
            backgroundColor: '#ffffffa0',
          },
          tooltip: {
            callbacks: {
              label: (tooltipItem) => {
                const { label, dataIndex, dataset } = tooltipItem;
                return `${label} : ${dataset.data[dataIndex]} ${dataset.unit}`;
              },
            },
          },
          legend: {
            display: true,
            position: 'top',
            align: 'center',
          },
        },
        layout: {
          padding: 10,
        },
        hover: {
          animationDuration: 0,
        },
        scales: {
          x: {
            display: true,
            stacked: true,
          },
          y: {
            ticks: {
              precision: 0,
              beginAtZero: true,
            },
            stacked: true,
          },
        },
      },
      // Categories for charts: this will sort the charts by categories
      statsCategories: {
        Marketing: {
          name: this.$t('message.CHART_CATEGORY_MARKETING'),
        },
        Development: {
          name: this.$t('message.CHART_CATEGORY_DEVELOPMENT'),
        },
        CustomerSuccess: {
          name: this.$t('message.CHART_CATEGORY_CUSTOMERSUCCESS'),
        },
        ProductLife: {
          name: this.$t('message.CHART_CATEGORY_PRODUCTLIFE'),
        },
      },
    };
  },

  computed: {
    /** Creating a breadcrumb to navigate and to understand where the user clicked */
    breadcrumb() {
      const breadcrumb = [{}, {}, {}];
      if (this.$store.state.shizenStats.stats.companies) {
        if (this.$route.params.companyId) {
          const text = this.$store.state.shizenStats.stats.companies
            .find(company => Number(company.id) === Number(this.$route.params.companyId)).name;
          breadcrumb[0] = { text, link: `${this.$route.params.companyId}` };
        }
        if (this.$route.params.teamId) {
          const text = this.$store.state.shizenStats.stats.companies
            .find(company => Number(company.id) === Number(this.$route.params.companyId)).teams
            .find(team => Number(team.id) === Number(this.$route.params.teamId)).name;
          const link = `${this.$route.params.companyId}/${this.$route.params.teamId}`;
          breadcrumb[1] = { text, link };
        }
        if (this.$route.params.userId) {
          const text = this.$store.state.shizenStats.stats.companies
            .find(company => Number(company.id) === Number(this.$route.params.companyId)).teams
            .find(team => Number(team.id) === Number(this.$route.params.teamId)).users
            .find(user => Number(user.id) === Number(this.$route.params.userId)).username;
          const link = `${this.$route.params.companyId}/${this.$route.params.teamId}/${this.$route.params.userId}`;
          breadcrumb[2] = { text, link };
        }
      }
      return breadcrumb;
    },
    /** Object: Filter charts by categories */
    chartsByCategories() {
      /** Getting all of the categories from statsCategories */
      const categories = Object.keys(this.statsCategories);
      /** Initializing the object that will receive ordered charts by categories */
      const chartDataByCategories = {};
      /** For each category, check if the chart in dataTypes has the category to be displayed in in category proprety */
      categories.forEach((category) => {
        chartDataByCategories[category] = [];
        Object.keys(this.dataTypes).forEach((key) => {
          if (this.dataTypes[key].category.includes(category)) {
            /** If yes, push the chart into the right category */
            if (this.chartData[key]) {
              chartDataByCategories[category].push(this.chartData[key]);
            }
          }
        });
      });
      /** Return the object */
      return chartDataByCategories;
    },
    /** Whether the periods section should be fully visible by default */
    defaultPeriodsExpanded() {
      return this.$route.query.periodsExpanded === 'true';
    },
    /** Object: Range of chart's visible values */
    visibleValuesRange() {
      if (!this.displayConfig) {
        return null;
      }
      const { chartPeriodObj, pointPeriodObj, chartEnd } = this.displayConfig;
      return {
        start: calcPeriodStartDate(chartEnd, chartPeriodObj, pointPeriodObj),
        end: chartEnd.clone().endOf('day'),
      };
    },
    /**
     * Object: Range of all values, including values not displayed.
     * Especially useful when building a cumulated chart (where increasingValues > 0).
     * eg: Values should be cumulated each month from the 1st of each month
     *     => need the values from the 1st day of month
     */
    allValuesRange() {
      if (!this.displayConfig) {
        return null;
      }
      if (!this.displayConfig.increasingValues) {
        // No increasing values, no need for an extended range
        return this.visibleValuesRange;
      }
      const { chartEnd, configStart } = computeConfigStart(this.displayConfig, this.visibleValuesRange.start);
      return { start: this.$moment(configStart), end: chartEnd };
    },
    /** Number: Display config ID */
    presetId: {
      get() {
        const { presetId } = this.$route.query;
        if (presetId === null || isNaN(presetId)) {
          return this.$store.getters.defaultMonthlyDisplayConfig.id;
        }
        return Number(presetId);
      },
      set(newVal) {
        const query = Object.assign({}, this.$route.query);
        if (newVal !== Number(query.presetId)) {
          query.presetId = newVal;
          this.$router.replace({ query });
        }
      },
    },
    /** Object: Return Shizen data from the page you want to show */
    selectedStats() {
      const { stats } = this.$store.state.shizenStats;
      const { companies } = stats;
      const { userId, teamId, companyId } = this.$route.params;
      if (!companies) {
        return {};
      }
      if (this.$route.params && companyId) {
        const currentCompany = companies.find(company => Number(company.id) === Number(companyId));
        if (teamId) {
          const currentTeam = currentCompany.teams.find(team => Number(team.id) === Number(teamId));
          if (userId) {
            return currentTeam.users.find(user => Number(user.id) === Number(userId));
          }
          return currentTeam;
        }
        return currentCompany;
      }
      return stats;
    },
    /** Array: Return stats from companies */
    allDatas() {
      if (!this.selectedStats) {
        return [];
      }
      const { teamId, companyId } = this.$route.params;
      if (teamId) {
        return this.selectedStats.users || [];
      }
      if (companyId) {
        return this.selectedStats.teams || [];
      }
      return this.selectedStats.companies || [];
    },
    /** Array: List of cards filtered from a search bar */
    filteredCardsList() {
      const effectiveSearch = this.cardsSearch.sAccentless.toUpperCase().split(/[\s,-./']/);
      return this.allDatas.filter((team) => {
        const uppperName = (team.name || '').toUpperCase();
        const inName = !effectiveSearch.some(term => !uppperName.includes(term));
        const uppperUsername = (team.username || '').toUpperCase();
        const inUsername = !effectiveSearch.some(term => !uppperUsername.includes(term));
        return inName || inUsername;
      });
    },
    /** Array: List of cards limited to 30 items */
    limitedCardsList() {
      return this.filteredCardsList.slice(0, this.cardsDataLimit);
    },
    /** Boolean: Return true or false if companies are loading or not */
    allCompaniesLoading() {
      return this.$store.state.shizenStats.statsLoading;
    },
    /** String: Return the type of the data (companies / teams / users) */
    getTypeData() {
      const { userId, teamId, companyId } = this.$route.params;
      if (userId) {
        return 'users';
      }
      if (teamId) {
        return 'teams';
      }
      if (companyId) {
        return 'companies';
      }
      return 'allDatas';
    },
    /** String: Return the right name compared data we want to show */
    displayName() {
      if (this.getTypeData !== 'users' && this.getTypeData !== 'allDatas') {
        return this.selectedStats.name || '';
      }
      if (this.getTypeData === 'users') {
        return this.selectedStats.username || '';
      }
      return 'Shizen';
    },
    displayListTitle() {
      if (this.getTypeData === 'teams') {
        return this.$t('message.LIST_OF_USERS');
      }
      if (this.getTypeData === 'companies') {
        return this.$t('message.LIST_OF_TEAMS');
      }
      return this.$t('message.LIST_OF_COMPANIES');
    },
    /** String: Return a string with the number of actions created / finished */
    displayActions() {
      return `${
        this.$tc('message.VH_AC_ABS_NUMBER_TEXT', this.selectedStats.sumNActionsCreated,
          { val: this.selectedStats.sumNActionsCreated })
        + this.$t('message.COMMA')
      } ${
        this.$tc('message.COMPLETED_ACTIONS_', this.selectedStats.sumNActionsFinished,
          { val: this.selectedStats.sumNActionsFinished })
      }`;
    },
    /** String: Return a string with the number of problems created / finished */
    displayProblems() {
      return `${
        this.$tc('message.OVERVIEW_CREATED_PB', this.selectedStats.sumNPbCreated,
          { n: this.selectedStats.sumNPbCreated })
          + this.$t('message.COMMA')
      } ${
        this.$tc('message.OVERVIEW_FINISHED_PB', this.selectedStats.sumNPbFinished,
          { n: this.selectedStats.sumNPbFinished })
      }`;
    },
    // Custom configs
    ...mapState({
      customConfigs: state => state[GET_INDICATOR_DISPLAY_CONFIGS.stateKey] || [],
      customConfigsLoading: state => state[GET_INDICATOR_DISPLAY_CONFIGS.loadingKey],
    }),
    /** Object: Chart's display configuration (understandable by ChartHelper) */
    chartConfiguration() {
      const { pointPeriodObj } = this.displayConfig;
      return {
        ...this.displayConfig,
        pointPeriod: pointPeriodObj.period,
        pointUnit: pointPeriodObj.unit,
        pointStartDay: pointPeriodObj.startDay,
        configStart: this.visibleValuesRange.start.clone(),
      };
    },
    /** This generates random colors for teams and users icons
     * The colors generated are stored into the sessionStorage and so will be deleted when the user closes his navigator
     */
    generateIconColor() {
      const randomColor = getRandomColor();
      if (this.$route.params.userId) {
        if (sessionStorage && sessionStorage.getItem(this.$route.params.userId)) {
          return `fill:${sessionStorage.getItem(this.$route.params.userId)}`;
        }
        sessionStorage.setItem(this.$route.params.userId, randomColor);
      }
      if (this.$route.params.teamId) {
        if (sessionStorage && sessionStorage.getItem(this.$route.params.teamId)) {
          return `fill:${sessionStorage.getItem(this.$route.params.teamId)}`;
        }
        sessionStorage.setItem(this.$route.params.teamId, randomColor);
      }
      return `fill:${randomColor}`;
    },
  },

  watch: {
    /** Checking if the display has been changed using the queries
     * watching the config directly made some bugs
     */
    $route(to, from) {
      if (from.query !== to.query) {
        this.isRefreshDone = false;
      }
    },
  },

  mounted() {
    // Refresh the data with a delay to "wait" for a custom range value from ChartPeriodSelector
    setTimeout(() => {
      this.refresh();
    }, 50);
  },

  /** Checking if the user has access to Shizen Stats */
  beforeRouteEnter(to, from, next) {
    window.scrollTo(0, 0);
    next((comp) => {
      if (!comp.currentUser || !comp.currentUser.accessShizenUsersStats) {
        next('/');
      } else if (!comp.currentTeam || !comp.currentTeam.accessShizenUsersStats) {
        next('/');
      } else {
        next();
      }
    });
  },

  beforeRouteUpdate(to, from, next) {
    if (from.path !== to.path) {
      this.cardsDataLimit = 30;
      this.cardsSearch = '';
      this.$nextTick(() => {
        this.refresh();
        if (!this.selectedStats.isFormatted) {
          this.dataIsFormatting = true;
          setTimeout(() => {
            this.$store.commit(
              `shizenStats/${FORMAT_SHIZEN_STATS}`,
              { dataType: this.getTypeData, ids: this.$route.params },
            );
            this.dataIsFormatting = false;
          }, 500);
        }
        this.setDataObject();
        // Scroll the page to top when the user is changing between shizen, company, team or user
        this.$refs.scrollableContent.scrollTo(0, 0);
        if (this.$route.params.companyId) {
          this.getCompanyPicture();
        }
      });
    }
    next();
  },

  methods: {
    timeChartOptions(chart) {
      const stepSizeObject = this.definedStepSize(chart);
      return {
        plugins: {
          datalabels: {
            formatter: (value) => {
              const time = secondsToArray(value);
              let formattedTime = '';
              if (time[3] > 0) {
                formattedTime += `${(time[3].toString().length < 2)
                  ? `0${time[3]}`
                  : time[3]}${this.$t('message.SHORT_DAY')} `;
              }
              if (time[0] > 0) {
                formattedTime += `${(time[0].toString().length < 2) ? `0${time[0]}` : time[0]}:`;
              } else {
                formattedTime += '00:';
              }
              if (time[1] > 0) {
                formattedTime += `${(time[1].toString().length < 2) ? `0${time[1]}` : time[1]}:`;
              } else {
                formattedTime += '00:';
              }
              if (time[2] > 0) {
                formattedTime += `${(time[2].toString().length < 2)
                  ? `0${Math.round(time[2])}`
                  : Math.round(time[2])}`;
              } else {
                formattedTime += '00';
              }
              return formattedTime;
            },
            anchor: 'start',
            align: 'top',
            offset: 0,
            color: '#58595B',
            backgroundColor: '#ffffffa0',
          },
          tooltip: {
            callbacks: {
              label: (tooltipItem) => {
                /** Entering the condition if we set an unit in chart options */
                /** If the unit is 'time' this return a formatted time */
                const data = tooltipItem.dataset.data[tooltipItem.dataIndex];
                if (tooltipItem.dataset.unit === 'time') {
                  const time = secondsToArray(data);
                  let formattedTime = '';
                  if (time[3] > 0) {
                    formattedTime += `${(time[3].toString().length < 2)
                      ? `0${time[3]}`
                      : time[3]}${this.$t('message.SHORT_DAY')} `;
                  }
                  if (time[0] === 0 && time[1] === 0 && time[2] === 0) {
                    return '0s';
                  }
                  if (time[0] > 0) {
                    formattedTime += `${(time[0].toString().length < 2) ? `0${time[0]}` : time[0]}:`;
                  } else {
                    formattedTime += '00:';
                  }
                  if (time[1] > 0) {
                    formattedTime += `${(time[1].toString().length < 2) ? `0${time[1]}` : time[1]}:`;
                  } else {
                    formattedTime += '00:';
                  }
                  if (time[2] > 0) {
                    formattedTime += `${(time[2].toString().length < 2)
                      ? `0${Math.round(time[2])}`
                      : Math.round(time[2])}`;
                  } else {
                    formattedTime += '00';
                  }
                  return formattedTime;
                }
                /** Else, display the data with the string unit */
                return `${tooltipItem.label} : ${data} ${tooltipItem.dataset.unit}`;
              },
            },
          },
          legend: {
            display: true,
            position: 'top',
            align: 'center',
          },
        },
        layout: {
          padding: 20,
        },
        hover: {
          animationDuration: 0,
        },
        scales: {
          x: {
            stacked: true,
          },
          y: {
            ticks: {
              stepSize: stepSizeObject.stepSize,
              beginAtZero: true,
              callback: (label) => {
                const time = secondsToArray(label);

                let formattedTime = '';
                if (stepSizeObject.unitFormat === 'day') {
                  return `${time[3]}${this.$t('message.SHORT_DAY')}`;
                }

                formattedTime += `${(time[0].toString().length < 2)
                  ? `0${time[0]}`
                  : time[0]}:`;

                formattedTime += `${(time[1].toString().length < 2)
                  ? `0${time[1]}`
                  : time[1]}:`;

                formattedTime += `${(Math.round(time[2]).toString().length < 2)
                  ? `0${Math.round(time[2])}`
                  : Math.round(time[2])}`;
                return formattedTime;
              },
            },
            stacked: true,
          },
        },
      };
    },
    definedStepSize(chart) {
      const data = cloneDeep(chart.datasets[0].data);
      const max = data.sort((a, b) => b - a)[0];
      for (let i = 0, len = timeStepSizes.length; i < len; i++) {
        if (max > timeStepSizes[i].max) {
          return timeStepSizes[i];
        }
      }
      return timeStepSizes[timeStepSizes.length - 1];
    },
    /** Scrolltop button function executed from emit & on path change */
    scrollToTop() {
      this.$refs.scrollableContent.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    /** Checking if the scrolltop button should be visible or not */
    checkScrollHeight() {
      this.scrollTopVisible = this.$refs.scrollableContent.scrollTop >= 240;
    },
    /**
     * Get the company picture from Google CSE
     * Using localStorage to avoid to many API calls for the same picture
     */
    getCompanyPicture(company) {
      if (company && !this.$route.params.companyId) {
        const iconQuery = company.name;
        if (localStorage.getItem(`${company.id}CompanyPicture`)) {
          return localStorage.getItem(`${company.id}CompanyPicture`);
        }
        // eslint-disable-next-line max-len
        const url = `https://www.googleapis.com/customsearch/v1?key=AIzaSyDP4q19dX75JjN60U1OmGW9bHAE-T7KHh8&cx=2d4e5744e5fca426f&q=${iconQuery}+logo&searchType=image`;
        this.$http({ method: 'get', url }).then(({ data }) => {
          localStorage.setItem(`${company.id}CompanyPicture`, data.items[0].link);
          return data.items[0].link;
        });
      }
      if (this.$route.params.companyId) {
        const iconQuery = this.displayName;
        if (localStorage.getItem(`${this.$route.params.companyId}CompanyPicture`)) {
          this.summaryCompanyPicture = localStorage.getItem(`${this.$route.params.companyId}CompanyPicture`);
        } else {
          // eslint-disable-next-line max-len
          const url = `https://www.googleapis.com/customsearch/v1?key=AIzaSyDP4q19dX75JjN60U1OmGW9bHAE-T7KHh8&cx=2d4e5744e5fca426f&q=${iconQuery}+logo&searchType=image`;
          this.$http({ method: 'get', url }).then(({ data }) => {
            this.summaryCompanyPicture = data.items[0].link;
            localStorage.setItem(`${this.usersData.id}CompanyPicture`, data.items[0].link);
          }).catch(() => {
            this.summaryCompanyPicture = 'https://static.thenounproject.com/png/88781-200.png';
          });
        }
      }
      return '';
    },
    /** Going back, with a refresh to reload the right charts */
    previousPath() {
      this.$router.push({ name: this.$route.meta.fallbackRoute, query: this.$route.query });
    },
    /** Get the data and preparing values for the charts */
    setDataObject() {
      /** Get all of the keys to make one chart per key */
      if (!this.selectedStats.data) {
        return;
      }
      const keynames = Object.keys(this.selectedStats.data);
      /** This indicator is needed to use the buildCustomConfigChart function, that needs an indicator itself. */
      const fakeIndicator = {
        objectiveIsMax: 0,
        name: '',
        unit: '',
        inputPeriodUnit: 'd',
        team: 0,
        teamName: '',
        objectives: {},
        objective: 0,
      };

      /** Initializing the data that will be pushed for the charts */
      const dataPushed = {};

      /** Looping through all the keys to prepare the data per chart */
      keynames.forEach((keyname) => {
        /** Initializing the empty data, preparing the functions */
        const trustedValue = Object.values(this.selectedStats.data[keyname]).find(v => !isNaN(v.value) || !!v.value);
        const datasets = [];
        const chartHelper = new ChartHelper();

        /** Getting all of the custom parameters such as chart name, color and type defined in dataTypes. */
        const {
          name = keyname,
          type = 'line',
          color = '#FFD500',
          category = 'Uncategorized',
          unit = '',
        } = this.dataTypes[keyname] || {};
        /** If the chart got multiple values, this enters the condition */
        if (trustedValue && trustedValue.value instanceof Object) {
          Object.keys(trustedValue.value).forEach((key, orderValue) => {
            const chartName = [];
            const specValues = Object.assign({}, this.selectedStats.data[keyname]);
            Object.keys(specValues).forEach((date) => {
              specValues[date] = { ...specValues[date], value: specValues[date].value[key] };
            });
            const points = chartHelper.buildCustomConfigChart(
              fakeIndicator,
              specValues,
              this.chartConfiguration,
              /** This "true" line is used to define working days (here, from Monday to Sunday) */
              [true, true, true, true, true, true, true],
              this.visibleValuesRange,
            );
            chartName.push(name[orderValue]);
            /** Pushing the charts data into the dataset (tension is for the angle of the curve) */
            datasets.push({
              label: name[orderValue],
              data: points.points.map(p => p.data),
              backgroundColor: color[orderValue],
              tension: 0,
              pointHitRadius: 5,
              unit,
            });
            const labels = points.points.map(p => p.tooltip.title);
            dataPushed[keyname] = {
              chartName,
              datasets,
              labels,
              type,
              category,
              unit,
            };
          });
        /** If the chart got only one value, go in else */
        } else {
          const points = chartHelper.buildCustomConfigChart(
            fakeIndicator,
            this.selectedStats.data[keyname],
            this.chartConfiguration,
            /** This "true" line is used to define working days (here, from Monday to Sunday) */
            [true, true, true, true, true, true, true],
            this.visibleValuesRange,
          );
          datasets.push({
            label: name,
            data: points.points.map(p => p.data),
            fill: false,
            borderColor: color,
            tension: 0,
            pointHitRadius: 5,
            unit,
          });
          const labels = points.points.map(p => p.tooltip.title);

          dataPushed[keyname] = {
            datasets,
            labels,
            type,
            category,
            unit,
          };
        }
      });
      /** Initializing filling charts function with the data newly created */
      this.chartData = dataPushed;
    },
    /** Periods section has been (un-)expanded */
    periodsExpanded(expanded) {
      const query = Object.assign({}, this.$route.query);
      query.periodsExpanded = expanded ? 'true' : 'false';
      if (query.periodsExpanded !== this.$route.query.periodsExpanded) {
        this.$router.replace({ query });
      }
    },

    /** Call the API with a custom range as param */
    refresh(forceRefresh) {
      if (!this.allCompaniesLoading) {
        const start = this.allValuesRange.start.startOf('day').format('YYYY-MM-DD HH:mm:ss');
        const end = this.allValuesRange.end.endOf('day').format('YYYY-MM-DD HH:mm:ss');
        this.$store.dispatch(`shizenStats/${FETCH_SHIZEN_STATS}`, {
          range: { start, end },
          dataType: this.getTypeData,
          ids: this.$route.params,
          forceRefresh,
        }).then(() => {
          if (!this.displayName) {
            this.$router.push('/shizen-stats/');
            this.setDataObject();
          } else {
            this.setDataObject();
            // This disables the refresh button, because the data is now loaded.
            // The button will be available again if the user changes the displayConfig
            this.isRefreshDone = true;
            if (this.$route.params.companyId) {
              this.getCompanyPicture();
            }
          }
        });
      }
    },
    exportToExcel() {
      this.$http.get('/server/ratings').then(({ data }) => {
        if (data) {
          exportRatingsToExcel(data);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";

.shizen-stats-overview {
  &__no-data {
    background: white;
    padding: 1em 0;
    color: red;
    text-align: center;
    font-weight: bold;
  }

  &__breadcrumb {
    padding-bottom: 0.5em;
    margin-bottom: 1em;
    width: 100%;
    border-bottom: 2px solid lightgrey;
    &__item {
      cursor: pointer;
      transition: 0.3s ease;
    &:hover {
      color: #2A5A91;
    }
    }
  }
  &__loading {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 10003;
  }

  &__container {
    position: relative;
  }

  &__charts {
    margin: 2em 0;
    padding-bottom: 2px;
    background: #dfdfdf;
    &__categories {
      background: #dfdfdf;
      &__disabled {
        color: #58595b40;
      }
    }
  }

  &__informations {
    padding: 2em;
    background: white;

    &__button {
      margin-bottom: 2em;
      margin-left: 1em;
    }

    &__header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;

      &__texts {
        display: flex;
      }

      @media (max-width: $smartphone-portrait) {
        flex-direction: column;
        justify-content: flex-start;
      }
    }

    &__profile {
      margin-left: 1em;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      @media (max-width: $smartphone-portrait) {
        margin-left: 0;
      }

      &__name {
        margin-top: 0.5em;
        font-weight: bold;
        text-align: center;
      }

      &__img {
        width: 50px;
        height: 50px;
        object-fit: contain;
        border-radius: 100%;
        background-color: #dfdfdf;
      }

      &__stats {
        margin: 0 2em;

        @media (max-width: $smartphone-portrait) {
          margin: 1em 1em;
        }

        &__btn {
          margin-right: 1em;
          margin-left: 0.5em;
          &__container {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
            width: 30%;

            @media (max-width: $smartphone-portrait) {
              flex-direction: column;
              width: 100%;
            }
          }

          &__text {
            margin-top: 0.5em;
            color: red;
            text-align: right;
            font-weight: bold;
          }

          &__animation {
            animation: scaleButton 2.5s ease-in-out infinite;
          }
        }
      }
    }

    &__stats {
      margin: 2em -2em 0;
    }

    &__other {
      margin: 1em 0;
    }
  }

  &__card-container {
    display: flex;
    flex-wrap: wrap;
    overflow-x: auto;
  }
}

.chart {
  position: relative;
  background: white;
  width: calc(100% / 3 - 2em);
  margin: 1em;
  &__item {
    &__disabled {
      opacity: 0.5;
    }
  }
  &__empty-message {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  @media (max-width: $smartphone-landscape) {
    width: calc(100% / 2 - 2em);
  }
  @media (max-width: $smartphone-portrait) {
    width: calc(100% - 2em);
  }
  &-container {
    background: #dfdfdf;
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
  }
}

@keyframes scaleButton {
  0% {
    transform: scale(1);
  }

  25% {
    transform: scale(1.1);
  }

  50% {
    transform: scale(1);
  }

  75% {
    transform: scale(1.1);
  }
}

</style>
